const ctaButton = document.querySelector(".fp-utility-bar__cta");
const ctaDropdown = document.querySelector(".fp-utility-bar__cta-dropdown");

ctaButton.addEventListener("mouseenter", () => {
  ctaButton.setAttribute("open", true);
  ctaDropdown.classList.remove("hidden");

  ctaDropdown.addEventListener("mouseenter", () => {
    ctaButton.setAttribute("open", true);
    ctaDropdown.classList.remove("hidden");
  });

  ctaDropdown.addEventListener("mouseleave", () => {
    ctaButton.removeAttribute("open");
    ctaDropdown.classList.add("hidden");
  });
});

ctaButton.addEventListener("mouseleave", () => {
  ctaButton.removeAttribute("open");
  ctaDropdown.classList.add("hidden");
});
